export function assertNever(x) {
    throw new Error(`Unexpected value: ${String(x)}`);
}
export function atOrThrow(items, index, message = `Expected array item at index ${index}.`) {
    const item = items[index];
    if (item === undefined) {
        throw new Error(message);
    }
    return item;
}
export function firstOrThrow(items, message = "Expected a non-empty array.") {
    return atOrThrow(items, 0, message);
}
export function cyclicAtOrThrow(items, index, message = "Expected a non-empty array.") {
    if (items.length === 0) {
        throw new Error(message);
    }
    const adjustedIndex = ((index % items.length) + items.length) % items.length;
    const item = items[adjustedIndex];
    if (item === undefined) {
        throw new Error(message);
    }
    return item;
}
export function getOrThrow(map, key, message = `Expected map to contain key: ${String(key)}.`) {
    const value = map.get(key);
    if (value === undefined) {
        throw new Error(message);
    }
    return value;
}
export function captureGroupOrThrow(match, index, message = `Expected regex match to contain group at index ${index}.`) {
    const group = match[index];
    if (group === undefined) {
        throw new Error(message);
    }
    return group;
}
//# sourceMappingURL=helpers.js.map